export class TipoDespesa {
  codDespesa: string;
  tipoDespesa: string;
  tipoDocumento: string;
  contaRazao: string;
}
